const networkHandler = () => {
  // navigator.connection.addListener('change', console.log);
};

export default networkHandler;
